import ApiClient from "../helpers/ApiClient";

const baseCnaeEndpoint = () => `/cnae`;

const listCnaes = () =>
  ApiClient.apiClientDev.get(`${baseCnaeEndpoint()}/codigos`);

const listItensServico = () =>
  ApiClient.apiClientDev.get(`${baseCnaeEndpoint()}/itens_servico`);

const listCnaeRelacionamento = () =>
  ApiClient.apiClientDev.get(`${baseCnaeEndpoint()}/relacionamentos`);

const createCnaeRelacionamento = (data) =>
  ApiClient.apiClientDev.post(`${baseCnaeEndpoint()}/relacionamentos`, data);

const destroyCnaeRelacionamento = (uid) =>
  ApiClient.apiClientDev.delete(`${baseCnaeEndpoint()}/relacionamentos/${uid}`);

const CnaeApiClient = {
  listCnaes,
  listItensServico,
  listCnaeRelacionamento,
  createCnaeRelacionamento,
  destroyCnaeRelacionamento,
};
export default CnaeApiClient;
